import React from 'react';
import { Building2, Cloud, Laptop } from 'lucide-react';

const ITEnvironments = () => {
  const environments = [
    {
      icon: <Building2 className="w-12 h-12" />,
      title: 'Onsite',
      description: 'Full on-premises IT infrastructure management with dedicated local support.',
      features: ['Local network management & support', 'Local server management', 'Physical hardware support', 'Onsite technicians'],
    },
    {
      icon: <Cloud className="w-12 h-12" />,
      title: 'Hybrid',
      description: 'Best of both worlds - combine cloud flexibility with on-premises control.',
      features: ['Cloud + on-prem integration', 'Flexible scalability', 'Optimized costs'],
    },
    {
      icon: <Laptop className="w-12 h-12" />,
      title: 'Remote',
      description: 'Complete cloud-based infrastructure with remote management and support.',
      features: ['100% cloud infrastructure', 'Remote monitoring', 'Global accessibility'],
    },
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Flexible IT Management for Any Environment
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            CyberTek manages IT infrastructure across Onsite, Hybrid, and Remote environments,
            tailored to your business needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {environments.map((env, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-20 h-20 bg-gradient-to-br from-blue-100 to-blue-50 rounded-xl flex items-center justify-center text-[#2995FF] mb-6">
                {env.icon}
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{env.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{env.description}</p>
              <ul className="space-y-2">
                {env.features.map((feature, fIndex) => (
                  <li key={fIndex} className="flex items-center space-x-2 text-sm text-gray-700">
                    <span className="w-1.5 h-1.5 bg-[#2995FF] rounded-full"></span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ITEnvironments;
